import { flow, types } from 'mobx-state-tree'
import { BaseRouteState, Policy } from '@shared/data-access'
import { actions } from '@sr/routes/common'
import { TestResultModel } from '@sr/data-access'

export const ScriptPreControlRouteState = BaseRouteState.named(
  'ScriptPreControlRouteState'
)
  .props({
    policyId: types.maybeNull(types.string),
    policy: types.maybeNull(types.reference(Policy)),
    testResults: types.maybeNull(types.reference(TestResultModel)),
  })
  .views((self) => ({
    get hasStartedTest() {
      return !!self.resultsParsed?.health?.answers
    },
    get resultsParsed() {
      return self.testResults && JSON.parse(self.testResults?.testResults)
    },
  }))
  .actions((self) => ({
    afterAttach() {
      self.loadDependencies()
    },
    loadDependencies: flow(function* loadDependencies() {
      self.setLoading('ScriptPreControlRouteState')
      try {
        yield self.loadPolicy()
        yield self.loadTestResults()
      } finally {
        self.removeLoading('ScriptPreControlRouteState')
      }
    }),
    ...actions(self),
  }))
